// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TP1n","index":"styles_index__PYim7"};